import { toFloatBigNumber } from '@/util/big'
import { formatEther, parseEther } from 'ethers/lib/utils'

export const useFormatSwEth = () => formatEther
export const useParseSwEth = () => parseEther
export const useToSwEthFloat = () => toFloatBigNumber
